import { render, staticRenderFns } from "./compoTest.vue?vue&type=template&id=44c20726"
import script from "./compoTest.vue?vue&type=script&lang=js"
export * from "./compoTest.vue?vue&type=script&lang=js"
import style0 from "./compoTest.vue?vue&type=style&index=0&id=44c20726&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports